<template>
  <div v-show="show">
    <b-card title="Categoria" header-tag="header" footer-tag="footer">
      <div slot="header" class="row mb-0 align-items-right">
        <div class="col-12 text-right ">
          <div class="switch-container">
            <span class="switch-label mr-1">
              Status
            </span>

            <toggle-button class="mb-0"
              v-model="form.status"
              :width="70"
              :height="25"
              :labels="{checked: 'Ativo', unchecked: 'Inativo'}"/>
          </div>
        </div>
      </div>

      <div class="row">
        <b-form-group class="col-12 col-sm-6"
          label="* Nome"
          label-for="name"
          description="">

          <b-form-input id="name"
            v-model="form.name"
            placeholder="Titulo"
            required
            :class="{
              'is-invalid': submitted && form.errors.has('name'),
              'is-valid': submitted && !form.errors.has('name')
            }"
            @input="slugify">
          </b-form-input>
        </b-form-group>

        <b-form-group class="col-12 col-sm-6"
          label="Slug"
          label-for="slug"
          description="(Se vazia será gerada uma slug automática)">

          <b-form-input id="slug"
            v-model="form.slug"
            placeholder="Slug"
            :class="{
              'is-invalid': submitted && form.errors.has('slug'),
              'is-valid': submitted && !form.errors.has('slug')
            }"
            @change="userEditedSlug = true">
          </b-form-input>
        </b-form-group>
      </div>

      <slot name="footer"></slot>
    </b-card>
  </div>
</template>

<script>
import { clone } from 'lodash'
import slugify from 'slugify'
import { slugifyOptions } from '@/plugins'

export default {
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default () {
        return {
          media: []
        }
      }
    },

    http: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      show: true,
      userEditedSlug: false,

      empty: {
        name: '',
        slug: '',
        status: true
      }
    }
  },

  methods: {
    slugify () {
      const self = this

      if (this.userEditedSlug) {
        return
      }

      self.show = false
      self.form.slug = slugify(self.form.name, slugifyOptions)
      self.$nextTick(() => {
        self.show = true
      })
    }
  },

  created () {
    const self = this

    if (self.instance.id) {
      self.form.setInitialValues(self.instance)
    } else {
      self.form.setInitialValues(this.empty)
      self.form.withData(clone(this.empty))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/Bl/StoryCategory.vue